<template>
  <v-container>
    <div
      data-v-fae5bece
      class="v-card__title headline lighten-2 v-card__title--primary"
      style="padding: 0px"
    >
      <div>Izbor radne snage</div>

      <button
        id="closeModalBtn"
        @click.prevent="closeModalInModal_izbor_radne_snage"
        class="v-btn v-btn--flat white"
      >
        <v-icon>close</v-icon>
      </button>
    </div>

    <div data-v-fae5bece class="spacer"></div>

    <v-form ref="form1" v-model="valid" lazy-validation>
      <v-layout>
        <!-- <v-flex xs2 pa-2>
          <v-menu
            ref="menu"
            v-model="menuModal"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
          >
            <v-text-field
              slot="activator"
              v-model="dateFormattedModal"
              label="Datum"
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              @blur="dateModal = parseDate(dateFormattedModal)"
            ></v-text-field>
            <v-date-picker
              v-model="dateModal"
              no-title
              @input="menuModal = false"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs1 pa-2>
          <v-menu
            ref="menuModal2"
            :close-on-content-click="false"
            v-model="menuModal2"
            :nudge-right="0"
            :return-value.sync="timeModal"
            transition="scale-transition"
            lazy
            offset-y
            full-width
            min-width="290px"
            @input="
              (value) =>
                value && $refs.picker && ($refs.picker.selectingHour = true)
            "
          >
            <v-text-field
              slot="activator"
              v-model="timeModal"
              label=""
              readonly
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
            ></v-text-field>
            <v-time-picker
              v-model="timeModal"
              ref="picker"
              full-width
              landscape
              class="mt-3"
              format="24hr"
              :allowed-minutes="allowedStep"
              v-on:change="$refs.menuModal2.save(timeModal)"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuModal2 = false"
                >Cancel</v-btn
              >
            </v-time-picker>
          </v-menu>
        </v-flex> -->
        <v-flex xs2 pa-2>
          <v-text-field
            v-model="timeModalNew"
            label="Radnih sati"
            type="number"
            min="0"
            ref="element7"
            :disabled="!edit"
            @change="proveraVrednosti"
            onkeydown="javascript: return event.keyCode == 69 ? false : true"
          ></v-text-field>
        </v-flex>
        <template v-if="tip_operacije === 'Berba'">
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="executed"
              label="Ubrano"
              type="number"
              ref="element1"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              suffix="kg"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>

        <template v-if="!eksterni_radnik">
          <v-flex xs10 pa-2 style="max-width: 75%">
            <!-- item-value="id" -->
            <v-autocomplete
              v-model="employee_to_select"
              :items="employee_to_items"
              :item-text="getFieldText"
              label="Radnik"
              item-value="employee.id"
              persistent-hint
              return-object
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              ref="element3"
              :disabled="!edit"
              multiple
              chips
              deletable-chips
              hide-no-data
            ></v-autocomplete>
          </v-flex>
          <v-flex
            xs1
            pa-2
            style="
              padding-top: 20px !important;
              padding-left: 0px !important;
              padding-top: 20px !important;
              max-width: 40px !important;
            "
          >
            <v-icon
              slot="activator"
              @click="otvoriSifarnik"
              style="color: #018389; padding-left: 0px; font-weight: bold"
              title="Dodavanje radnika"
              v-if="edit"
              >add</v-icon
            >
          </v-flex>
        </template>
        <template v-else>
          <v-flex xs4 pa-2>
            <v-text-field
              v-model="external_first_name"
              label="Kontakt ime"
              ref="element4"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs3 pa-2>
            <v-text-field
              v-model="external_last_name"
              label="Kontakt prezime"
              ref="element5"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="external_contact"
              label="Telefon"
              ref="element6"
              type="number"
              :disabled="!edit"
            ></v-text-field>
          </v-flex>
        </template>
      </v-layout>
    </v-form>
    <v-form ref="formModal" v-model="validModalNew" lazy-validation>
      <v-layout row wrap>
        <v-flex xs3 pa-2>
          <v-checkbox
            label="Eksterni radnik/grupa"
            v-model="eksterni_radnik"
            :checked="eksterni_radnik"
            @change="onCheckboxChange1"
            :disabled="!edit"
          ></v-checkbox>
        </v-flex>
        <template v-if="eksterni_radnik">
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="workers_in_group"
              label="Radnika u grupi"
              type="number"
              min="1"
              :disabled="!edit"
              @change="changeRadnikaUGrupi"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="dnevnica"
              label="Dnevnica"
              type="number"
              suffix="RSD"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
              @change="changeDnevnica"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2>
            <v-text-field
              v-model="work_price"
              label="Iznos"
              type="number"
              suffix="RSD"
              :rules="[(v) => !!v || 'Obavezan podatak']"
              required
              :disabled="!edit"
              @change="changeUkupno"
            ></v-text-field>
          </v-flex>
          <v-flex xs2 pa-2> </v-flex>
        </template>
        <template v-else>
          <v-flex xs6 pa-2> </v-flex>
        </template>
      </v-layout>
      <v-layout>
        <v-flex xs10 pa-2>
          <v-text-field
            v-model="opis"
            label="Opis"
            :disabled="!edit"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 pa-2 style="max-width: 10%">
          <v-text-field
            v-model="uradjeno"
            label="Urađeno"
            type="number"
            suffix="ha"
            min="0"
            :disabled="!edit || !prikazi_uneto"
          ></v-text-field>
        </v-flex>
        <v-flex
          xs1
          pa-2
          style="
            text-align: right !important;
            padding-right: 20px !important;
            padding-top: 5px !important;
          "
        >
          <v-icon
            slot="activator"
            id="FloatingButton"
            @click="otvoriModal_izabrani_redova"
            title="Dodavanje redova"
          ></v-icon>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs8>
          <v-btn :disabled="!edit" @click="submit" class="AppButtonFilled"
            >Sačuvaj</v-btn
          >
          <v-btn @click="clear" class="AppButtonOutlined" v-if="edit"
            >odustani</v-btn
          >
          <v-btn
            @click="clear"
            class="AppButtonOutlined"
            :disabled="!edit"
            v-else
            style="border: none !important"
            >odustani</v-btn
          >
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_sorti !== 0">
            <p class="gornji_text" v-html="broj_sorti"></p>
            <p class="donji_text" v-html="formatTekstaSorta2(broj_sorti)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">sorti</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_redova !== 0">
            <p class="gornji_text" v-html="broj_redova"></p>
            <p class="donji_text" v-html="formatTekstaRed2(broj_redova)"></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text">redova</p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2>
          <div class="div_prozorce" v-if="broj_kalemova !== 0">
            <p class="gornji_text" v-html="broj_kalemova"></p>
            <p
              class="donji_text"
              v-html="formatTekstaKalem2(broj_kalemova)"
            ></p>
          </div>
          <div class="div_prozorce" v-else>
            <p class="gornji_text">-</p>
            <p class="donji_text"
            v-html="formatTekstaKalem2(0)"></p>
          </div>
        </v-flex>
        <v-flex xs1 pa-2 v-if="1 === 2">
          <template v-if="povrsina > 1000">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p
                class="gornji_text"
                v-html="Math.round(povrsina / 100) / 100"
              ></p>
              <p class="donji_text">ha</p>
            </div>
          </template>
          <template v-else-if="povrsina > 0">
            <div class="div_prozorce" v-if="broj_sorti !== 0">
              <p class="gornji_text" v-html="Math.round(povrsina) / 100"></p>
              <p class="donji_text">ar</p>
            </div>
          </template>
          <template v-else>
            <div class="div_prozorce">
              <p class="gornji_text">-</p>
              <p class="donji_text">ar</p>
            </div>
          </template>
        </v-flex>
      </v-layout>
    </v-form>

    <v-dialog
      v-model="dialogNote_operacije"
      scrollable
      content-class="ModalInModalGrafic"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <VineyardOperation
              @close="handleDataCloseOperacije($event)"
              :operationType="operacija"
            ></VineyardOperation>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <v-dialog
      v-model="dialogNote_izabrani_redovi"
      scrollable
      content-class="ModalInModalVineyardRows"
    >
      <v-container style="padding: 0px">
        <div class="DataTable">
          <div data-v-fae5bece class="v-card">
            <MyComponentVineYardRows
              @newdata="handleDataVineyardRows($event)"
              @close="handleDataCloseVineyardRows($event)"
              :item="edit_item_pom"
              :vineyardId="id_vineyard_pom"
              :ID="ID"
              :plaintObject="objVineyardPlaintPom"
              :vineyardOperationExecution="objVineyardOperationExecutionPom"
              :izmena="edit"
              :tipOperacije="tip_pom"
              :berba_krcenje="berba_krcenje"
            ></MyComponentVineYardRows>
          </div>
        </div>
        <!-- /.addingToTank -->
      </v-container>
    </v-dialog>

    <TokenComponent ref="frmtoken" />
  </v-container>
</template>

        <script>
import { readJSON, daLiJeVinarija } from "../helpers/Functions";
import TokenComponent from "../components/Token";
import VineyardOperation from "../views/EmployeeVinogradi.vue";

import MyComponentVineYardRows from "./VineyardOperationVineYardRowsComponentPom.vue";
import { colorInterpolate } from "@amcharts/amcharts5/.internal/core/util/Animation";

export default {
  props: [
    "articleId",
    "ID",
    "plaintObject",
    "vineyardOperationExecution",
    "item",
    "tip_operacije",
    "edit",
    "berba_krcenje",
  ],
  name: "myform",
  components: {
    TokenComponent,
    VineyardOperation,
    MyComponentVineYardRows,
  },
  data: () => ({
    endHour: 0,
    endMinute: 0,
    hours: [
      0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
    ],
    ID_item: 0,
    eksterni_radnik: false,
    work_price: undefined,
    external_first_name: undefined,
    external_last_name: undefined,
    external_contact: undefined,
    workers_in_group: undefined,
    menuModal: "",
    menuModal2: "",
    menuModal2New: "",
    timeModal: null,
    timeModalNew: undefined,
    dateModal: null,
    // work_valuta: undefined,
    // currency_items: [],
    valid: true,
    validModal: true,
    validModalNew: true,
    employee_to_items: [],
    employee_to_select: [],
    dateFormattedModal: null,
    pagination: {
      sortBy: "id",
      rowsPerPage: 10000000,
    },
    headers_modal_work_forces: [
      { text: "Radnik", value: "Name" },
      { text: "Trajanje", value: "duration" },
      { text: "Urađeno", value: "executed" },
      { text: "Grupa", value: "workersInGroup" },
      { text: "Iznos", value: "price" },
      { text: "Funkcije", value: "funkcije", sortable: false },
    ],
    items_modal_work_forces: [],
    items_modal_work_forces_save: [],
    opis: undefined,
    edit_item: undefined,
    edit_item_pom: undefined,
    eksterni_radnik_pom: false,
    jm_items: [{ name: "Čokota" }, { name: "Redova" }, { name: "Ha" }],
    jm_select: undefined,
    executed: undefined,

    dialogNote_operacije: false,
    operacija: "Naslon",

    broj_sorti: 0,
    broj_redova: 0,
    broj_kalemova: 0,
    povrsina: 0,

    pomFromNew: undefined,
    pomToNew: undefined,

    dialogNote_izabrani_redovi: false,
    objVineyardPlaintPom: undefined,
    objVineyardOperationExecutionPom: undefined,
    id_vineyard_pom: undefined,
    objVineyardOperationRows: [],
    tip: "radnik",
    tip_pom: undefined,
    dnevnica: undefined,
    uradjeno: undefined,
    prikazi_uneto: true,

tekstBiljka: "",
vinarija: true,
  }),
  methods: {
    proveraVrednosti(e) {
      if (e < 0) {
        alert("Trajanje ne može biti manje od nule.");
        this.timeModalNew = 0;
      }
    },
    changeRadnikaUGrupi(e) {
      if (this.dnevnica !== 0 && this.dnevnica !== undefined)
        this.work_price = Math.round(this.dnevnica * e * 100) / 100;
    },
    changeDnevnica(e) {
      if (this.workers_in_group !== 0 && this.workers_in_group !== undefined)
        this.work_price = Math.round(this.workers_in_group * e * 100) / 100;
    },
    changeUkupno(e) {
      if (this.workers_in_group !== 0 && this.workers_in_group !== undefined)
        this.dnevnica = Math.round((e / this.workers_in_group) * 100) / 100;
    },
    otvoriModal_izabrani_redova() {
      this.id_vineyard_pom = this.articleId;
      this.objVineyardOperationExecutionPom = this.vineyardOperationExecution;
      this.objVineyardPlaintPom = this.plaintObject;
      this.edit_item_pom = this.edit_item;
      this.tip_pom = this.tip;

      this.dialogNote_izabrani_redovi = true;
    },
    handleDataVineyardRows: function (e) {
      // this.dialogNote_izabrani_redovi = false;
    },
    handleDataCloseVineyardRows: function (e) {
      this.dialogNote_izabrani_redovi = false;

        this.objVineyardOperationRows = [];
      
        this.objVineyardPlaintPom = undefined;
        this.id_vineyard_pom = undefined;
        

      if(this.ID_item > 0){
        this.objVineyardOperationExecutionPom = undefined;
      }
      this.edit_item_pom = undefined;
        this.tip_pom = undefined;
        

      let pomObj;
      let _this = this;

      let rows = e.rows;
      let blocks = e.blocks;

      this.uradjeno = Math.round(e.povrsina / 100) / 100;

      if (rows.length > 0) this.prikazi_uneto = false;
      else this.prikazi_uneto = true;

      rows.forEach(function (e) {
        // let lokID;

        // lokID = entry.id_pom.split("_")[0];

        if (e.id !== undefined && e.id !== null)
          pomObj = {
            id: e.id,
            executedNumberFrom: e.executedNumberFrom,
            executedNumberTo: e.executedNumberTo,
            vineyardRow: e.vineyardRow,
            description: "",
            grapeVariety: {
              id: e.grapeVariety.id,
            },
            vineyardOperationRowParentId: e.vineyardOperationRowParentId,
            distanceBetweenPlants: e.distanceBetweenPlants,
          };
        else
          pomObj = {
            id: null,
            executedNumberFrom: e.executedNumberFrom,
            executedNumberTo: e.executedNumberTo,
            vineyardRow: e.vineyardRow,
            description: "",
            grapeVariety: {
              id: e.grapeVariety.id,
            },
            vineyardOperationRowParentId: e.vineyardOperationRowParentId,
            distanceBetweenPlants: e.distanceBetweenPlants,
          };

        _this.objVineyardOperationRows.push(pomObj);
      });

      this.objVineyardOperationBlock = blocks;

      this.izracunajMere();

      if (this.edit_item !== undefined) {
        this.getAllSifarnik(this.ID);
      }
    },
    otvoriSifarnik(event) {
      this.operacija = "Naslon";
      this.dialogNote_operacije = true;
    },
    handleDataCloseOperacije: function (e) {
      // this.getAllEmployees(e.name, e.lastname);
      this.dialogNote_operacije = false;
    },
    closeModalInModal_izbor_radne_snage() {
      let complex;

      complex = {
        save: this.items_modal_work_forces_save,
        show: this.items_modal_work_forces,
      };

      this.$emit("close", complex);
    },
    convertMinToTime(locMinutes) {
      return locMinutes / 60;
    },
    convertTimeToMinute(locTime) {
      //let pomArray = locTime.toString().split(":");

      //var minutes = Number(pomArray[0]) * 60 + Number(pomArray[1]);
      var minutes = locTime * 60;

      return minutes;
    },
    onCheckboxChange1(newValue) {
      if (newValue) {
        setTimeout(() => {
          let inputEl = this.$refs.element4.$el.querySelector("input");
          inputEl.select();
        }, 200);
        if (this.workers_in_group === undefined) this.workers_in_group = 1;
      } else this.employee_to_select = [];
    },
    izracunajMere() {
      let _this = this;
      var counts = {};
      var rows = {};

      this.broj_kalemova = 0;
      this.povrsina = 0;

      this.objVineyardOperationRows.forEach(function (e) {
        _this.broj_kalemova =
          _this.broj_kalemova +
          Number(e.executedNumberTo - e.executedNumberFrom + 1);

        counts[e.grapeVariety.id] = 1 + (counts[e.grapeVariety.id] || 0);
        rows[e.vineyardRow.id] = 1 + (rows[e.vineyardRow.id] || 0);
        // rows[e.id] = 1 + (rows[e.id] || 0);



        // let distanceBetweenPlants = 0;
        // let pomStr = localStorage.getItem("vinarija");

        // if (pomStr === "alea") distanceBetweenPlants = 0.8;
        // else if (pomStr === "winedb") distanceBetweenPlants = 1.2;

        _this.povrsina =
          _this.povrsina +
          Number(e.vineyardRow.distanceBetweenRows) *
            (e.executedNumberTo - e.executedNumberFrom + 1) *
            Number(e.distanceBetweenPlants !== null && e.distanceBetweenPlants !== undefined ? e.distanceBetweenPlants : 0 );

      });
      
      // if (!this.prikazi_uneto)
        this.uradjeno = Math.round(this.povrsina / 100) / 100;

      this.broj_sorti = Object.keys(counts).length;
      this.broj_redova = Object.keys(rows).length;
    },
    formatTekstaSorta2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "sorta";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "sorte";
      else tekst = "sorti";

      return tekst;
    },
    formatTekstaKalem2(broj) {
      let tekst = "";

      if (this.vinarija){
        if (broj % 10 === 1 && broj !== 11) tekst = "čokot";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "čokota";
        else tekst = "čokota";
      }
      else {
        if (broj % 10 === 1 && broj !== 11) tekst = "biljka";
        else if (broj === 2 || broj === 3 || broj === 4) tekst = "biljke";
        else tekst = "biljaka";        
      };

      return tekst;
    },
    formatTekstaRed2(broj) {
      let tekst = "";

      if (broj % 10 === 1 && broj !== 11) tekst = "red";
      else if (broj === 2 || broj === 3 || broj === 4) tekst = "reda";
      else tekst = "redova";

      return tekst;
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;

      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    editItem(item) {
      this.edit_item = item;
      this.ID_item = item.id;
      this.timeModalNew = item.duration / 60;

      if (
        item.employee === null &&
        item.vineyardOperationWorkForceInGroups.length === 0
      ) {
        this.eksterni_radnik = true;
      } else this.eksterni_radnik = false;

      this.eksterni_radnik_pom = this.eksterni_radnik;
      this.objVineyardOperationRows = item.vineyardOperationRows;

      let _this = this;

      if (item.vineyardOperationRows.length > 0) this.prikazi_uneto = false;
      else this.prikazi_uneto = true;

      this.izracunajMere();

      if (item.vineyardOperationWorkForceInGroups.length === 0) {
        if (item.employee !== null) {
          let obj = {
            id: null,
            employee: {
              id: item.employee.id,
              firstName: item.employee.firstName,
              lastName: item.employee.lastName,
            },
          };

          this.employee_to_select.push(obj);
        }
      } else this.employee_to_select = item.vineyardOperationWorkForceInGroups;

      this.external_first_name = item.externalFirstName;
      this.external_last_name = item.externalLastName;
      this.external_contact = item.externalContact;

      if (this.tip_operacije !== "Berba") {
        this.jm_select = this.jm_items.find(
          (x) => x.name === item.executedUnit
        );

        this.executed = item.executed;
      } else this.executed = item.harvestQuantity;

      if (item.workersInGroup !== null)
        this.workers_in_group = item.workersInGroup;

      if (item.price !== null) {
        this.work_price = item.price;
        if (item.workersInGroup !== null)
          this.dnevnica =
            Math.round((this.work_price / this.workers_in_group) * 100) / 100;
      } else {
        this.work_price = undefined;
        this.dnevnica = undefined;
      }

      this.uradjeno = item.executed;
      this.opis = item.description;
    },
    deleteItem(item) {
      if (this.ID !== 0) this.deleteSifarnik(item.id);
      else {
        let ind = 0;

        ind = this.items_modal_work_forces.findIndex((x) => x === item);

        if (ind >= 0) {
          this.items_modal_work_forces.splice(ind, 1);
          this.items_modal_work_forces_save.splice(ind, 1);
        }
      }
    },
    deleteSifarnik(id) {
      this.$http
        .delete(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/work_force/" +
            id,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnik();
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .delete(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/work_force/" +
                        id,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnik();
                      this.clear();
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    // submitVreme(event) {
    //   event.preventDefault();
    //   let bool = true;

    //   let niz = this.timeModalNew.split(":");

    //   if (niz.length === 2) {
    //     if (
    //       Number(niz[0]) >= 0 &&
    //       Number(niz[0]) < 24 &&
    //       Number(niz[1]) >= 0 &&
    //       Number(niz[1]) < 60
    //     )
    //       bool = true;
    //     else bool = false;
    //   } else bool = false;

    //   if (bool) this.$refs.menuModal2New.save(this.timeModalNew);
    //   else {
    //     alert("Vreme nije dobro uneto, format mora biti ČČ:MM.");
    //     this.timeModalNew = "00:00";
    //   }
    // },
    formatTime(time) {
      let HH = time.split(":")[0];
      let mm = time.split(":")[1];

      return HH + ":" + mm;
    },
    formatDate1(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    changeSort(column) {
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
      }
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    allowedStep: (m) => m % 5 === 0,
    clear() {
      this.prikazi_uneto = true;

      this.objVineyardOperationRows = [];

      this.$refs.formModal.reset();

      if (this.tip_operacije === "Berba" && this.$refs.element1 !== undefined)
        this.$refs.element1.reset();

      if (this.$refs.element2 !== undefined) this.$refs.element2.reset();

      if (this.$refs.element3 !== undefined) this.$refs.element3.reset();

      if (this.$refs.element7 !== undefined) this.$refs.element7.reset();

      if (this.$refs.element4 !== undefined) {
        this.$refs.element4.reset();
        this.$refs.element5.reset();
        this.$refs.element6.reset();
      }

      this.$refs.formModal.reset();

      this.ID_item = 0;

      // this.setDate();

      this.edit_item = undefined;

      this.povrsina = 0;
      this.broj_kalemova = 0;
      this.broj_redova = 0;
      this.broj_sorti = 0;
    },
    getAllSifarnik() {
      this.$http
        .get(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/" +
            this.ID,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.srediObjekat(response.data);
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/" +
                        this.ID,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.srediObjekat(response.data);
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    changeSifarnik() {
      this.vineyardOperationExecution.vineyardOperationWorkForces =
        this.items_modal_work_forces_save;

      this.$http
        .put(
          this.globalServiceLocation +
            this.globalPort +
            "/vineyard_operation_execution/update",
          this.vineyardOperationExecution,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          this.getAllSifarnik();
          this.clear();
        })
        .catch((e) => {
          // // console.log(e.response);
          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .put(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/vineyard_operation_execution/update",
                      complexObjectGlobal,
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      this.getAllSifarnik();
                      this.clear();
                    })
                    .catch((e) => {
                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    // getAllValute() {
    //   this.$http
    //     .get(this.globalServiceLocation + this.globalPort + "/currency/all", {
    //       headers: {
    //         "Content-Type": "application/json",
    //         Authorization: "Bearer  " + localStorage.getItem("user-token"),
    //       },
    //     })
    //     .then((response) => {
    //       // // console.log(response.data);

    //       this.currency_items = response.data;
    //     })
    //     .catch((e) => {
    //       // // console.log(e.response);

    //       if (!e.response) {
    //         alert(
    //           this.$t("error.message")
    //         );
    //       } else {
    //         if (e.response.status === 401) {
    //           this.$refs.frmtoken
    //             .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
    //             .then((result) => {
    //               // // console.log(result);
    //               // // console.log("Novi token - " + localStorage.getItem("user-token"));

    //               this.$http
    //                 .get(
    //                   this.globalServiceLocation +
    //                     this.globalPort +
    //                     "/currency/all",
    //                   {
    //                     headers: {
    //                       "Content-Type": "application/json",
    //                       Authorization:
    //                         "Bearer  " + localStorage.getItem("user-token"),
    //                     },
    //                   }
    //                 )
    //                 .then((response) => {
    //                   // // console.log(response.data);

    //                   this.currency_items = response.data;
    //                 })
    //                 .catch((e) => {
    //                   // // console.log(e.response);

    //                   let pomError = readJSON(e.response.data.message);
    //                   alert(pomError);
    //                 });
    //             });
    //         } else {
    //           let pomError = readJSON(e.response.data.message);
    //           alert(pomError);
    //         }
    //       }
    //     });
    // },
    getFieldText(item) {
      if (item.employee !== undefined && item.employee !== null)
        return `${item.employee.firstName} ${item.employee.lastName}`;
      else return "";
    },
    getAllEmployees(ime, prezime) {
      this.$http
        .get(
          this.globalServiceLocation + this.globalPort + "/employee/all/basic",
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: "Bearer  " + localStorage.getItem("user-token"),
            },
          }
        )
        .then((response) => {
          let _this = this;

          response.data.forEach(function (e) {
            let obj = {
              employee: e,
            };

            _this.employee_to_items.push(obj);
          });

          // this.employee_to_items = response.data;

          // if (ime !== undefined && ime !== null) {
          //   let index;

          //   index = this.employee_to_items.findIndex(
          //     (x) => x.firstName === ime && x.lastName === prezime
          //   );

          //   if (index >= 0)
          //     this.employee_to_select = this.employee_to_items[index];
          // }
        })
        .catch((e) => {
          // // console.log(e.response);

          if (!e.response) {
            alert(
              this.$t("error.message")
            );
          } else {
            if (e.response.status === 401) {
              this.$refs.frmtoken
                .osvezavanjeTokena(localStorage.getItem("user-refresh-token"))
                .then((result) => {
                  // // console.log(result);
                  // // console.log("Novi token - " + localStorage.getItem("user-token"));

                  this.$http
                    .get(
                      this.globalServiceLocation +
                        this.globalPort +
                        "/employee/all/basic",
                      {
                        headers: {
                          "Content-Type": "application/json",
                          Authorization:
                            "Bearer  " + localStorage.getItem("user-token"),
                        },
                      }
                    )
                    .then((response) => {
                      // // console.log(response.data);

                      this.employee_to_items = response.data;

                      // if (ime !== undefined && ime !== null) {
                      //   let index;

                      //   index = this.employee_to_items.findIndex(
                      //     (x) => x.firstName === ime && x.lastName === prezime
                      //   );

                      //   if (index >= 0)
                      //     this.employee_to_select =
                      //       this.employee_to_items[index];
                      // }
                    })
                    .catch((e) => {
                      // // console.log(e.response);

                      let pomError = readJSON(e.response.data.message);
                      alert(pomError);
                    });
                });
            } else {
              let pomError = readJSON(e.response.data.message);
              alert(pomError);
            }
          }
        });
    },
    submit() {
      if (this.eksterni_radnik === undefined) this.eksterni_radnik = false;

      if (!this.eksterni_radnik) {
debugger

        if (this.employee_to_select !== null){
          if (this.employee_to_select.length === 0)
            this.employee_to_select = null;
        }
        
        if (
          this.$refs.form1.validate() &&
          this.$refs.formModal.validate()
        ) 
        if(this.employee_to_select !== null)
        {
          let complexObject;
          let complexObjectSave;
          let pomEmployee = [];

            this.employee_to_select.forEach(function (entry) {
              let obj;

              if (entry.id === undefined)
                obj = {
                  employee: {
                    id: entry.employee.id,
                  },
                };
              else
                obj = {
                  id: entry.id,
                  employee: {
                    id: entry.employee.id,
                  },
                };

              pomEmployee.push(obj);
            });

          if (this.tip_operacije !== "Berba") {
              complexObjectSave = {
                id: null,
                // date: this.dateModal + "T" + this.timeModal,
                duration: this.convertTimeToMinute(this.timeModalNew),
                // employee: pomEmployee,
                employee: null,
                vineyardOperationWorkForceInGroups: pomEmployee,
                externalFirstName: null,
                externalLastName: null,
                externalContact: null,
                workersInGroup: null,
                price: null,
                currency: null,
                vineyardOperationRows: this.objVineyardOperationRows,
                executed: this.uradjeno,
                executedUnit: "ha",
                harvestQuantity: null,
                harvestUnitOfMeasure: null,
                description: this.opis,
              };

              complexObject = {
                id: null,
                // date: this.dateModal + "T" + this.timeModal,
                duration: this.convertTimeToMinute(this.timeModalNew),
                // employee: this.employee_to_select,
                vineyardOperationWorkForceInGroups: pomEmployee,
                externalFirstName: null,
                externalLastName: null,
                externalContact: null,
                workersInGroup: null,
                price: null,
                currency: null,
                vineyardOperationRows: this.objVineyardOperationRows,
                executed: this.uradjeno,
                executedUnit: "ha",
                harvestQuantity: null,
                harvestUnitOfMeasure: null,
                description: this.opis,
              };
            } else {
              complexObjectSave = {
                id: null,
                // date: this.dateModal + "T" + this.timeModal,
                duration: this.convertTimeToMinute(this.timeModalNew),
                // employee: pomEmployee,
                employee: null,
                vineyardOperationWorkForceInGroups: pomEmployee,
                externalFirstName: null,
                externalLastName: null,
                externalContact: null,
                workersInGroup: null,
                price: null,
                currency: null,
                vineyardOperationRows: this.objVineyardOperationRows,
                executed: this.uradjeno,
                executedUnit: "ha",
                harvestQuantity: this.executed,
                harvestUnitOfMeasure: {
                  id: 7,
                },
                description: this.opis,
              };

              complexObject = {
                id: null,
                // date: this.dateModal + "T" + this.timeModal,
                duration: this.convertTimeToMinute(this.timeModalNew),
                employee: this.employee_to_select,
                externalFirstName: null,
                externalLastName: null,
                externalContact: null,
                workersInGroup: null,
                price: null,
                currency: null,
                vineyardOperationRows: this.objVineyardOperationRows,
                executed: this.uradjeno,
                executedUnit: "ha",
                harvestQuantity: this.executed,
                harvestUnitOfMeasure: {
                  id: 7,
                },
                description: this.opis,
              };
            }

          if (this.ID_item !== 0 && this.ID_item !== null) {
            complexObject.id = this.ID_item;
            complexObjectSave.id = this.ID_item;

            let ind = 0;
            ind = this.items_modal_work_forces.findIndex(
              (x) => x.id === this.ID_item
            );

            if (ind >= 0) {
              this.items_modal_work_forces.splice(ind, 1);
              this.items_modal_work_forces_save.splice(ind, 1);
            }

            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);
          } else if (this.edit_item !== undefined) {
            let ind = 0;

            if (!this.eksterni_radnik_pom)
              ind = this.items_modal_work_forces.findIndex(
                (x) => x.employee.id === this.edit_item.employee.id
              );
            else
              ind = this.items_modal_work_forces.findIndex(
                (x) =>
                  x.externalFirstName === this.edit_item.externalFirstName &&
                  x.externalLastName === this.edit_item.externalLastName
              );

            if (ind >= 0) {
              this.items_modal_work_forces.splice(ind, 1);
              this.items_modal_work_forces_save.splice(ind, 1);
            }

            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);

            this.clear();
          } else {
            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);

            this.clear();
          }

          if (this.ID !== 0) this.changeSifarnik();
        }
        
      } else {
        if (
          this.$refs.form1.validate() &&
          this.$refs.formModal.validate()
        ) {
          let complexObject;
          let complexObjectSave;
          let pomEmployee = [];

          let pomCena = null;

          if (this.work_price !== undefined) pomCena = this.work_price;

          if (this.workers_in_group !== undefined) {
              if (this.tip_operacije !== "Berba") {
                complexObjectSave = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: this.workers_in_group,
                  price: pomCena,

                  currency: {
                    id: 1,
                  },
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: null,
                  harvestUnitOfMeasure: null,
                  description: this.opis,
                };

                complexObject = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: this.workers_in_group,
                  price: pomCena,
                  currency: {
                    id: 1,
                    mark: "RSD",
                  },
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: null,
                  harvestUnitOfMeasure: null,
                  description: this.opis,
                };
              } else {
                complexObjectSave = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: this.workers_in_group,
                  price: pomCena,

                  currency: {
                    id: 1,
                  },
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: this.executed,
                  harvestUnitOfMeasure: {
                    id: 7,
                  },
                  description: this.opis,
                };

                complexObject = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: this.workers_in_group,
                  price: pomCena,
                  currency: {
                    id: 1,
                    mark: "RSD",
                  },
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: this.executed,
                  harvestUnitOfMeasure: {
                    id: 7,
                  },
                  description: this.opis,
                };
              }
            } else {
              if (this.tip_operacije !== "Berba") {
                complexObjectSave = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: null,
                  price: pomCena,
                  currency: null,
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: null,
                  harvestUnitOfMeasure: null,
                  description: this.opis,
                };

                complexObject = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: null,
                  price: pomCena,
                  currency: null,
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: null,
                  harvestUnitOfMeasure: null,
                  description: this.opis,
                };
              } else {
                complexObjectSave = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: null,
                  price: pomCena,
                  currency: null,
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: this.executed,
                  harvestUnitOfMeasure: {
                    id: 7,
                  },
                  description: this.opis,
                };

                complexObject = {
                  id: null,
                  // date: this.dateModal + "T" + this.timeModal,
                  duration: this.convertTimeToMinute(this.timeModalNew),
                  employee: null,
                  externalFirstName: this.external_first_name,
                  externalLastName: this.external_last_name,
                  externalContact: this.external_contact,
                  workersInGroup: null,
                  price: pomCena,
                  currency: null,
                  vineyardOperationRows: this.objVineyardOperationRows,
                  executed: this.uradjeno,
                  executedUnit: "ha",
                  harvestQuantity: this.executed,
                  harvestUnitOfMeasure: {
                    id: 7,
                  },
                  description: this.opis,
                };
              }
            }

          if (this.ID_item !== 0 && this.ID_item !== null) {
            complexObject.id = this.ID_item;
            complexObjectSave.id = this.ID_item;

            let ind = 0;
            ind = this.items_modal_work_forces.findIndex(
              (x) => x.id === this.ID_item
            );

            if (ind >= 0) {
              this.items_modal_work_forces.splice(ind, 1);
              this.items_modal_work_forces_save.splice(ind, 1);
            }

            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);
          } else if (this.edit_item !== undefined) {
            let ind = 0;

            if (!this.eksterni_radnik_pom)
              ind = this.items_modal_work_forces.findIndex(
                (x) => x.employee.id === this.edit_item.employee.id
              );
            else
              ind = this.items_modal_work_forces.findIndex(
                (x) =>
                  x.externalFirstName === this.edit_item.externalFirstName &&
                  x.externalLastName === this.edit_item.externalLastName
              );

            if (ind >= 0) {
              this.items_modal_work_forces.splice(ind, 1);
              this.items_modal_work_forces_save.splice(ind, 1);
            }

            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);

            this.clear();
          } else {
            this.items_modal_work_forces.push(complexObject);
            this.items_modal_work_forces_save.push(complexObjectSave);

            this.clear();
          }

          if (this.ID !== 0) this.changeSifarnik();
        }
      }
    },
    srediObjekat(val) {
      let _this = this;
      let newArray;

      if (val.vineyardOperationWorkForces !== undefined)
        newArray = val.vineyardOperationWorkForces;
      else if (
        val.vineyardOperationExecution.vineyardOperationWorkForces !== undefined
      )
        newArray = val.vineyardOperationExecution.vineyardOperationWorkForces;

      this.items_modal_work_forces = [];
      this.items_modal_work_forces_save = [];

      newArray.forEach(function (e) {
        if (typeof e === "object") {
          let complexObject;
          complexObject = {
            id: e.id,
            date: e.date,
            duration: e.duration,
            employee: e.employee,
            externalFirstName: e.externalFirstName,
            externalLastName: e.externalLastName,
            externalContact: e.externalContact,
            workersInGroup: e.workersInGroup,
            price: e.price,
            currency: e.currency,
            vineyardOperationRows: e.vineyardOperationRows,
            executed: e.executed,
            executedUnit: e.executedUnit,
            harvestQuantity: e.harvestQuantity,
            harvestUnitOfMeasure: e.harvestUnitOfMeasure,
            description: e.description,
            vineyardOperationWorkForceInGroups:
              e.vineyardOperationWorkForceInGroups,
          };

          let complexObjectSave;
          if (e.employee !== null && e.currency !== null) {
            if (_this.tip_operacije !== "Berba") {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: {
                  id: e.employee.id,
                },
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: {
                  id: e.currency.id,
                },
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: null,
                harvestUnitOfMeasure: null,
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            } else {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: {
                  id: e.employee.id,
                },
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: {
                  id: e.currency.id,
                },
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: e.harvestQuantity,
                harvestUnitOfMeasure: {
                  id: 7,
                },
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            }
          } else if (e.employee !== null) {
            if (_this.tip_operacije !== "Berba") {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: {
                  id: e.employee.id,
                },
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: null,
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: null,
                harvestUnitOfMeasure: null,
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            } else {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: {
                  id: e.employee.id,
                },
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: null,
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: e.harvestQuantity,
                harvestUnitOfMeasure: {
                  id: 7,
                },
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            }
          } else if (e.currency !== null) {
            if (_this.tip_operacije !== "Berba") {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: null,
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: {
                  id: e.currency.id,
                },
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: null,
                harvestUnitOfMeasure: null,
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            } else {
              complexObjectSave = {
                id: e.id,
                date: e.date,
                duration: e.duration,
                employee: null,
                externalFirstName: e.externalFirstName,
                externalLastName: e.externalLastName,
                externalContact: e.externalContact,
                workersInGroup: e.workersInGroup,
                price: e.price,
                currency: {
                  id: e.currency.id,
                },
                vineyardOperationRows: e.vineyardOperationRows,
                executed: e.executed,
                executedUnit: e.executedUnit,
                harvestQuantity: e.harvestQuantity,
                harvestUnitOfMeasure: {
                  id: 7,
                },
                description: e.description,
                vineyardOperationWorkForceInGroups:
                  e.vineyardOperationWorkForceInGroups,
              };
            }
          } else if (_this.tip_operacije !== "Berba") {
            complexObjectSave = {
              id: e.id,
              date: e.date,
              duration: e.duration,
              employee: null,
              externalFirstName: e.externalFirstName,
              externalLastName: e.externalLastName,
              externalContact: e.externalContact,
              workersInGroup: e.workersInGroup,
              price: e.price,
              currency: null,
              vineyardOperationRows: e.vineyardOperationRows,
              executed: e.executed,
              executedUnit: e.executedUnit,
              harvestQuantity: null,
              harvestUnitOfMeasure: null,
              description: e.description,
              vineyardOperationWorkForceInGroups:
                e.vineyardOperationWorkForceInGroups,
            };
          } else {
            complexObjectSave = {
              id: e.id,
              date: e.date,
              duration: e.duration,
              employee: null,
              externalFirstName: e.externalFirstName,
              externalLastName: e.externalLastName,
              externalContact: e.externalContact,
              workersInGroup: e.workersInGroup,
              price: e.price,
              currency: null,
              vineyardOperationRows: e.vineyardOperationRows,
              executed: e.executed,
              executedUnit: e.executedUnit,
              harvestQuantity: e.harvestQuantity,
              harvestUnitOfMeasure: {
                id: 7,
              },
              description: e.description,
              vineyardOperationWorkForceInGroups:
                e.vineyardOperationWorkForceInGroups,
            };
          }

          _this.items_modal_work_forces.push(complexObject);
          _this.items_modal_work_forces_save.push(complexObjectSave);
        }
      });
    },
  },
  watch: {
    berba_krcenje: function (val) {},
    dateModal(val) {
      this.dateFormattedModal = this.formatDate1(this.dateModal);
    },
    articleId: function (val) {
      // this.getAllValute();
      this.clear();

      if (val !== undefined && val !== 0) this.getAllEmployees();
    },
    ID: function (val) {},
    vineyardOperationExecution: function (val) {
      this.clear();
    },
    plaintObject: function (val) {
      if (val !== undefined && val !== 0) this.srediObjekat(val);
    },
    item: function (val) {
      if (val !== undefined) this.editItem(val);
      else this.clear();
    },
    tip_operacije: function (val) {},
    edit: function (val) {},
    berba: function (val) {},
  },
  mounted() {
    this.vinarija = daLiJeVinarija();

    if(this.vinarija)
      this.tekstBiljka = "Broj čokota";
    else{
      this.jm_items = [{ name: "Biljaka" }, { name: "Redova" }, { name: "Ha" }];
      this.tekstBiljka = "Broj biljaka";
    }
      

    // this.setTime();
  },
};
</script>

<style lang="scss" scoped>
.addingItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px !important;
}

div.v-input.Description.v-textarea.v-text-field {
  margin-top: 0px;
}

div.flex.pa-2 {
  padding-bottom: 0px !important;
  padding-top: 0px !important;
}

@import "./../assets/sass/parts/modalStyles";

.coupageItemComponentForm {
  max-width: 430px;
}

.Description textarea {
  height: 40px;
}

#FloatingButton {
  // position: absolute;
  width: 48px;
  height: 48px;
  font-size: 25px;
  border-radius: 50%;

  background-color: #018389;
  background-image: url("../assets/menuIcons/vinograd.svg");
  background-position: center;

  &:active,
  &:focus {
    box-shadow: none;
  }
}
.gornji_text {
  font-size: 18px !important;
  margin: 0px !important;
  padding-top: 10px !important;
  text-align: center;
}

.donji_text {
  font-size: 12px !important;
  text-align: center;
  margin: 0px !important;
  line-height: 0.1 !important;
}
</style>
